import React from 'react';
import { Icon, Message, Button, Modal, Header } from 'semantic-ui-react'
import _ from 'lodash';

const styles1 ={
  styMargin1:{
    // margin: '0.4em',
    // padding: '0.5em 0.5em 0.5em 1em',
  },
  styTable:{
    margin: '0.2em',
    // padding: '0.2em 0.2em 0.2em 0.2em',
  },
  styPaddMarg:{
    padding: '0.2em 0.1em 0.2em 0.1em',
    // margin: '0em 0em 0em 0em',
    fontSize: '0.9em'
  },
  styInput:{
    width: '4.2em',
  },
}

const Servicios = ({elemento, handleChange}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoServ' id={elemento.codigoServicio} checked={elemento.estadoServ} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
    </tr>
  )
};

const ListaServ = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <Servicios elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

const ServiciosOfer = ({elemento, handleChange}) => {
  
  const rango1Ini = (valor) => {
    if(valor!==null){
      return valor
    }else{
      return ''
    }
  }

  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoServOfer' id={elemento.codigoServicio} checked={elemento.estadoServ} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>

      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>

      <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput} autoComplete="off" name="porcDctoOferta" id={elemento.codigoServicio} value={rango1Ini(elemento.porcDctoOferta)} placeholder='% Dcto' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
      <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput} autoComplete="off" name="numDiasOferta" id={elemento.codigoServicio} value={rango1Ini(elemento.numDiasOferta)} placeholder='Días' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
    </tr>
  )
};

const ListaServOfer = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <ServiciosOfer elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

class ConfSerO2 extends React.Component {
  state={
      listServ: this.props.lisServ,
      listServTar: this.props.lisServTar,
      errors: this.props.errors,
      open: false,
  }

  // ordenarArrayAsc = (array, campo) => {
  //   array.sort(function (a, b) {
  //      return a[campo] > b[campo];
  //   });
  // }

  handleRefresh = () => {
    let arrayServTar=this.state.listServTar
    let arrayServ=this.state.listServ

    arrayServ.forEach((elemento, _id) => {
      if(elemento.estadoServ===true){
          arrayServTar.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            porcDctoOferta: null, numDiasOferta: null,
            _id: elemento._id, estadoServ: true});
          }
    })

    let arrayServ1 = arrayServ.filter(item => item.estadoServ===true);
    arrayServ1.forEach((elemento1, _id) => {
      arrayServ.forEach((elemento, _id) => {
        if(elemento.estadoServ===true && elemento1.codigoServicio===elemento.codigoServicio){
          const indexServ = arrayServ.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
          arrayServ.splice(indexServ, 1);
        }
      })
    })

    arrayServTar.forEach((elemento, _id) => {
      if(elemento.estadoServ===false){
          arrayServ.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            porcDctoOferta: null, numDiasOferta: null,
            _id: elemento._id, estadoServ: false});
          }
    })
    
    arrayServ1 = arrayServTar.filter(item => item.estadoServ===false);
    arrayServ1.forEach((elemento1, _id) => {
      arrayServTar.forEach((elemento, _id) => {
        if(elemento.estadoServ===false && elemento1.codigoServicio===elemento.codigoServicio){
          const indexServ = arrayServTar.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
          arrayServTar.splice(indexServ, 1);
        }
      })
    })

    // this.ordenarArrayAsc(arrayServTar, 'descrClaseServ')
    // this.ordenarArrayAsc(arrayServ, 'descrClaseServ')
    arrayServTar = _.orderBy(arrayServTar, ['descrClaseServ', 'descripcionServicio'])
    arrayServ = _.orderBy(arrayServ, ['descrClaseServ', 'descripcionServicio'])

    this.setState({listServTar: arrayServTar})
    this.setState({listServ: arrayServ})
    this.setState({open: false})
    this.setState({errors: []})
  }

  handleChange = (ev, elemento) => {
    if(ev.target.name === "estadoServOfer" ||
        ev.target.name === "porcDctoOferta" ||
        ev.target.name === "numDiasOferta"
      ){
      let listServTar=this.state.listServTar
      const indexServ = listServTar.findIndex( servicio => servicio.codigoServicio === ev.target.id );
      if(ev.target.name === "estadoServOfer"){
        if(elemento.estadoServ===false){
          listServTar[indexServ].estadoServ = true
        }else{
          listServTar[indexServ].estadoServ = false
        }
      }
      if(ev.target.name === "porcDctoOferta"){
        listServTar[indexServ].porcDctoOferta = ev.target.value
      }
      if(ev.target.name === "numDiasOferta"){
        listServTar[indexServ].numDiasOferta = ev.target.value
      }

      this.setState({listServTar});
    }

    if(ev.target.name === "estadoServ"){
      let listServ=this.state.listServ
      const indexServ = listServ.findIndex( servicio => servicio.codigoServicio === ev.target.id );
      if(elemento.estadoServ===false){
        listServ[indexServ].estadoServ = true
      }else{
        listServ[indexServ].estadoServ = false
      }
      this.setState({listServ});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel"){this.setState({open: true})};

    if(btnPress==="No"){
        this.setState({open: false})
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps){

    if(this.props.lisServ!==nextProps.lisServ){
        this.setState({listServ: this.props.lisServIni})
        this.setState({listServTar: this.props.lisServTarIni})
    }
    if(this.props.errors!==nextProps.errors){
      this.setState({errors: nextProps.errors})
    }
    this.setState({open: false})
  }

  shouldComponentUpdate(nextProps, nextState){
    if(this.props.lisServ!==nextProps.lisServ || this.state.listServ!==nextState.lisServ){
      return true
    }else{
      return false
    }
  }

  UNSAFE_componentWillUpdate(nextProps){
//entra si shouldComponentUpdate return true

}

  render(){
    const {listServ, listServTar, errors, open} = this.state;
    const a25151501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "25151501" );

    // console.log(this.state)
    // console.log(this.props)
    // console.log(listServ)
    // console.log(listServTar)
    return(
      <div>
        <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
          <div>
            <Button className='ui right labeled icon button' style={this.props.styles.titBuscar}>
                <i className='large hand point down yellow icon'></i>
                Oferta: {this.props.oferta}
            </Button>
            <Button name="btnRefr" id="btnRefr"  className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.handleRefresh}>
                <i className='large redo yellow icon'></i>
                Refrescar
            </Button>
            <Button name="btnVrInic" id="btnVrInic" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.props.handleVrinic}>
                <i className='large refresh yellow icon'></i>
                Valores iniciales
            </Button>
            {a25151501!==-1 &&
            <Button name="btnUpdDel" id="btnUpdDel" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                <i className='large save yellow icon'></i>
                Guardar
            </Button>
            }
          </div>
        }>
 
          <Header icon='edit' color='red' content='Modificar oferta' />
      
          <Modal.Content>
              <p>Esta usted seguro ?</p>
          </Modal.Content>
          <Modal.Actions>
              <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                  <Icon dato1="No" name='remove' /> No
              </Button>
              <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleSubmit(ev, listServTar)}>
                  <Icon dato1="Si" name='checkmark' /> Si
              </Button>
          </Modal.Actions>
        </Modal>

        {
            errors.length?<Message negative header="Los siguientes errores:"
            list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
        }

      <div style={this.props.styles.box}>
        <div className='ui blue inverted raised segment'>
          <a className='ui large label' style={this.props.styles.styTableSup}>Servicios asignados a la oferta</a>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className=''></th>
                <th className=''>Clase</th>
                <th className=''>Servicio</th>
                <th className=''>Descripción servicio</th>
                <th className='center aligned'>% Dcto</th>
                <th className='center aligned'>Días oferta</th>
              </tr>
            </thead>
            <ListaServOfer list={listServTar} handleChange={this.handleChange}/>
          </table>
        </div>

        <div className='ui blue inverted raised segment'>
          <a className='ui large label' style={this.props.styles.styTableInf}>Servicios sin asignar a la oferta</a>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
            <thead className=''>
              <tr className=''>
                <th className=''></th>
                <th className=''>Clase</th>
                <th className=''>Servicio</th>
                <th className=''>Descripción servicio</th>
              </tr>
            </thead>
            <ListaServ list={listServ} handleChange={this.handleChange}/>
          </table>
        </div>
      </div>
      </div>
    )
  }
}

export default ConfSerO2